import React from 'react';

//utils
import { MESSAGES } from '~/utils/message';
import { balanceFormatter, numberWithComma } from '~/utils/helperFunctions';
import { ORDER_DETAILS_CONTACT_STATS } from '~/utils/constants';

// Components
import Loader from '~/components/General/Loader';
import TotalCostSkeleton from './TotalCostSkeleton';

// MUI Componentss
import { Box, Tooltip, Typography } from '@mui/material';

// Assets
import { ContactInfoCIcon, TotalCostCIcon } from '~/assets/images';

// styles
import './styles.scss';

function TotalCost({ info, loading, rosCost, orderCost, additionalPageCost, hasAdditionalPage }) {

  const addOns = [];
  if (info?.costGsv) {
    addOns.push({ label: 'GSV cost', value: info.perMailerGsvCost });
  }
  if (info?.costRos || rosCost) {
    addOns.push({ label: 'ROS cost', value: info?.perMailerRosCost });
  }
  if (info?.costUvCoating) {
    addOns.push({ label: 'UV Coating cost', value: info?.perMailerUvCoatingCost });
  }
  if (hasAdditionalPage) {
    addOns.push({ label: 'additional page cost', value: additionalPageCost });
  }

  const tooltipContent = (
    <Typography className="info_txt">
      {numberWithComma(info.deliverableContacts)}&nbsp;
      <span className="txt">deliverable contacts&nbsp;</span>
      <span className="txt">x</span>&nbsp;
      {addOns.length ? <span>(</span> : <></>}
      {balanceFormatter(info.perMailerCost, 3)}
      <span className="txt">&nbsp;per mailer</span>
      {addOns.map((addOn, index) => (
        <React.Fragment key={addOn.label}>
          &nbsp;<span className="highlighted">+</span>&nbsp;
          {balanceFormatter(addOn.value)}
          <span className="txt">&nbsp;{addOn.label}</span>
          {index === addOns.length - 1 ? <span>)</span> : null}
        </React.Fragment>
      ))}
      </Typography>
    );

  if (loading) {
    return <TotalCostSkeleton />;
  }

  return (
    <Box className="total_cost">
      <Box className="total_card">
        <img width={40} height={40} src={TotalCostCIcon} alt="icon" />
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <span className="name">{MESSAGES.ORDERS.DETAIL.OVERVIEW.TOTAL_COST}</span>
          <Tooltip title={tooltipContent} placement="bottom-end" componentsProps={{
            tooltip: {
              className: 'totalCostTooltip',
              sx: {
                width: '226px',
                padding: '8px !important',
              }
            }
          }}>
            <img src={ContactInfoCIcon} alt="icon" style={{ cursor: 'pointer' }}/>
          </Tooltip>
        </Box>
        <Typography className="ammount">{balanceFormatter(orderCost, 3) || '-'}</Typography>
      </Box>
      {ORDER_DETAILS_CONTACT_STATS(info).map((card, index) => (
        <Box className="card" key={index}>
          <img src={card.icon} alt="icon" />
          <Box className="meta_info_box">
            <span className="meta_info">{card.title}</span>
            <Typography className="cost">{numberWithComma(card.value) || '-'}</Typography>
          </Box>
        </Box>
      ))}
    </Box>
  );
}

export default TotalCost;
